<!-- Main container -->
<div class="set-password-container">
  <!-- Header container -->
  <app-logo />

  <!-- Main content container -->
  <div class="set-password-container__main">
    <h1 class="set-password-container__main__h1">
      <span class="red__markup">{{ 'setPassword_title' | translate }}</span>
    </h1>
    <app-set-password-page></app-set-password-page>

    <div
      [ngClass]="{
        'set-password-container__main__img-bloc--myvetreco':
          env.isWhiteLabelMyVetReco,
      }"
      class="set-password-container__main__img-bloc"
    >
      <img
        role="presentation"
        alt=""
        src="./assets/images/reset_password_page.jpg"
      />
    </div>
  </div>
</div>
